import { CategoryWithSubcategories, Subcategory, SubcategoryItem } from "types/shared";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "store";

export interface CategoriesState {
  items: CategoryWithSubcategories[];
}

const initialState: CategoriesState = {
  items: [],
};

export const categories = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<CategoryWithSubcategories[]>) => {
      state.items = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCategories } = categories.actions;

export const categoriesSelector = ({ categories }: AppState): CategoryWithSubcategories[] => categories.items;

export const subcategoriesSelector = ({ categories }: AppState): SubcategoryItem[] =>
  categories.items.reduce<SubcategoryItem[]>((prev, next) => [...prev, ...next.subcategories], []);

export default categories.reducer;
